// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiMailOrderPharmacy {
    static getAttributeTypeMap() {
        return PharmacyBiMailOrderPharmacy.attributeTypeMap;
    }
}
PharmacyBiMailOrderPharmacy.discriminator = undefined;
PharmacyBiMailOrderPharmacy.additionalProperties = false;
PharmacyBiMailOrderPharmacy.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiMailOrderPharmacy.js.map